import {
  IReferralCodeDetail,
  IReferred,
  IReferrer,
} from "./referralCodeDetails.types"

export class ReferralCodeDetail implements IReferralCodeDetail {
  constructor(
    public code: string,
    public isBlacklisted: boolean,
    public referrer: IReferrer,
    public referred: IReferred[],
  ) {}

  get shareUrl() {
    return `${import.meta.env.SO_WEBSITE_URL}/r/${this.code}`
  }
}
